export enum SessionAuthenticationLevel {
    notAuthenticated = 0,
    pinOrBiometrics = 2,
    bankIdSubstantial = 8,
    bankIdHigh = 10,
}
